import React, { useState } from 'react';
import { Layout } from '../components/Layout';

export function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    companyName: '',
    yourName: '',
    email: '',
    phone: '',
    role: '',
    inquiryType: '',
    message: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement actual form submission to backend
    console.log('Form submitted:', formData);
    setSubmitted(true);
    // Reset form after 3 seconds
    setTimeout(() => {
      setSubmitted(false);
      setFormData({
        companyName: '',
        yourName: '',
        email: '',
        phone: '',
        role: '',
        inquiryType: '',
        message: '',
      });
    }, 3000);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const inputClasses = "w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-500 transition-colors";

  return (
    <Layout>
      {/* Header Section */}
      <section className="relative bg-white py-20 overflow-hidden">
        <div className="absolute inset-0 dot-grid opacity-40" />
        <div className="container mx-auto px-4 max-w-6xl relative z-10">
          <p className="text-brand-600 font-mono text-sm tracking-widest uppercase mb-4">
            Contact
          </p>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 tracking-tight mb-4">Contact Us</h1>
          <p className="text-xl text-gray-500 max-w-2xl">
            Get in touch to learn more about partnering with AOK Financial
          </p>
        </div>
      </section>

      {/* Contact Form and Info */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div>
              <p className="text-brand-600 font-mono text-sm tracking-widest uppercase mb-4">
                Inquiry
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-8 tracking-tight">
                Send Us a Message
              </h2>
              {submitted ? (
                <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 px-6 py-4 rounded-xl">
                  <p className="font-semibold">Thank you!</p>
                  <p className="text-sm mt-1 text-emerald-600">We'll respond within 1-2 business days.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div>
                    <label
                      htmlFor="companyName"
                      className="block text-xs font-mono uppercase tracking-wider text-gray-500 mb-2"
                    >
                      Company Name <span className="text-brand-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      required
                      value={formData.companyName}
                      onChange={handleChange}
                      className={inputClasses}
                      placeholder="Your brokerage name"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="yourName"
                      className="block text-xs font-mono uppercase tracking-wider text-gray-500 mb-2"
                    >
                      Your Name <span className="text-brand-600">*</span>
                    </label>
                    <input
                      type="text"
                      id="yourName"
                      name="yourName"
                      required
                      value={formData.yourName}
                      onChange={handleChange}
                      className={inputClasses}
                      placeholder="Your full name"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="email"
                      className="block text-xs font-mono uppercase tracking-wider text-gray-500 mb-2"
                    >
                      Email <span className="text-brand-600">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className={inputClasses}
                      placeholder="you@company.com"
                    />
                  </div>

                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label
                        htmlFor="phone"
                        className="block text-xs font-mono uppercase tracking-wider text-gray-500 mb-2"
                      >
                        Phone
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className={inputClasses}
                        placeholder="+1 (555) 123-4567"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="role"
                        className="block text-xs font-mono uppercase tracking-wider text-gray-500 mb-2"
                      >
                        Role/Title
                      </label>
                      <input
                        type="text"
                        id="role"
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        className={inputClasses}
                        placeholder="CEO, CTO, etc."
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="inquiryType"
                      className="block text-xs font-mono uppercase tracking-wider text-gray-500 mb-2"
                    >
                      Inquiry Type <span className="text-brand-600">*</span>
                    </label>
                    <select
                      id="inquiryType"
                      name="inquiryType"
                      required
                      value={formData.inquiryType}
                      onChange={handleChange}
                      className={inputClasses}
                    >
                      <option value="">Select an inquiry type</option>
                      <option value="partnership">Partnership Inquiry</option>
                      <option value="integration">Technical Integration</option>
                      <option value="pricing">Pricing & Terms</option>
                      <option value="support">Technical Support</option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div>
                    <label
                      htmlFor="message"
                      className="block text-xs font-mono uppercase tracking-wider text-gray-500 mb-2"
                    >
                      Message <span className="text-brand-600">*</span>
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                      rows={6}
                      className={inputClasses}
                      placeholder="Tell us about your needs..."
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-brand-500 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-brand-600 transition-all duration-200 hover:scale-[1.01]"
                  >
                    Send Message
                  </button>
                </form>
              )}
            </div>

            {/* Contact Information */}
            <div>
              <p className="text-brand-600 font-mono text-sm tracking-widest uppercase mb-4">
                Reach Out
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mb-8 tracking-tight">
                Direct Contact
              </h2>
              <div className="bg-white border border-gray-200 rounded-xl p-8 space-y-6 shadow-sm">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2 flex items-center text-sm">
                    <svg className="w-4 h-4 mr-2 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    Partnership Inquiries
                  </h3>
                  <a
                    href="mailto:partnerships@aokfin.com"
                    className="text-brand-600 hover:text-brand-500 font-mono text-sm ml-6 transition-colors"
                  >
                    partnerships@aokfin.com
                  </a>
                </div>

                <div>
                  <h3 className="font-semibold text-gray-900 mb-2 flex items-center text-sm">
                    <svg className="w-4 h-4 mr-2 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    General Inquiries
                  </h3>
                  <a
                    href="mailto:info@aokfin.com"
                    className="text-brand-600 hover:text-brand-500 font-mono text-sm ml-6 transition-colors"
                  >
                    info@aokfin.com
                  </a>
                </div>

                <div className="pt-4 border-t border-gray-200">
                  <h3 className="font-semibold text-gray-900 mb-3 text-sm">
                    Response Time
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    We typically respond to all inquiries within 1-2 business
                    days. For urgent technical issues, please mark your inquiry
                    type as "Technical Support" for priority handling.
                  </p>
                </div>
              </div>

              <div className="mt-6 bg-brand-50 border border-brand-200 rounded-xl p-6">
                <h3 className="font-semibold text-gray-900 mb-2 flex items-center text-sm">
                  <svg className="w-4 h-4 mr-2 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  Need API Documentation?
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Visit our{' '}
                  <a
                    href="/docs"
                    className="text-brand-600 hover:text-brand-500 font-semibold transition-colors"
                  >
                    API Documentation
                  </a>{' '}
                  page for comprehensive guides and interactive testing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
